import { z } from "zod";
export const BugReportProblemTypeEnum = z.enum([
    "translation_error",
    "content_error",
    "technical_bug",
    "other",
]);
export const BugReportStatusEnum = z.enum([
    "open",
    "in_progress",
    "fixed",
    "closed",
    "wont_fix",
]);
export const ConsoleLogEntrySchema = z.object({
    level: z.enum(["log", "warn", "error", "unhandled"]),
    message: z.string(),
    timestamp: z.string(),
    stack: z.string().optional(),
});
export const CreateBugReportPayloadSchema = z.object({
    problem_type: BugReportProblemTypeEnum,
    description: z.string().min(1).max(1000),
    page_url: z.string().max(2000),
    page_info: z.string().max(500),
    screenshot_url: z.string().nullable().default(null),
    extra_screenshot_urls: z.array(z.string()).max(5).default([]),
    console_logs: z.array(ConsoleLogEntrySchema).max(100).default([]),
    user_agent: z.string().max(500),
    viewport: z.string().max(50),
    language: z.string().max(10),
});
export const BugReportSchema = z.object({
    id: z.string(),
    user_uid: z.string(),
    user_email: z.string().nullable().optional(),
    user_name: z.string().nullable().optional(),
    problem_type: BugReportProblemTypeEnum,
    description: z.string(),
    page_url: z.string(),
    page_info: z.string(),
    screenshot_url: z.string().nullable(),
    extra_screenshot_urls: z.array(z.string()).default([]),
    console_logs: z.array(ConsoleLogEntrySchema),
    server_logs: z.string().nullable(),
    user_agent: z.string(),
    viewport: z.string(),
    language: z.string(),
    status: BugReportStatusEnum,
    github_issue_url: z.string().nullable(),
    github_issue_number: z.number().nullable(),
    admin_comments: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const UpdateBugReportPayloadSchema = z.object({
    status: BugReportStatusEnum.optional(),
    admin_comments: z.string().max(5000).optional(),
});
